const config = {
  //eslint-disable-next-line
  API_BASE: process.env.REACT_APP_API_URL ?? 'https://dev.ms-idm.academiarafaeltoro.com.br',
  LINK_SIMULATORO: process.env.REACT_APP_LINK_SIMULATORO ?? 'https://dev.simulatoro.academiarafaeltoro.com.br',
};

export default config;